<header>
  <nav>
    <span class="logo">
      <img class="stack-logo" src="./assets/stack-white.svg" />
      <h1 class="brand">TechStack</h1>
    </span>
    <app-social-links></app-social-links>
  </nav>
</header>
